<mat-tab-group *dtDataLoad="event; error: error != null; errorTemplate: errorTemplate">
  <mat-tab label="Status" i18n-label>
    <div class="tab-content">
      <dt-event-status [event]="event" (isDeleting)="isDeleting = $event"></dt-event-status>
    </div>
  </mat-tab>

  <mat-tab label="Teilnehmer" i18n-label>
    <dt-event-participants-table [event]="event"></dt-event-participants-table>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <div class="editable-tab-label">
        <ng-container i18n>Konfiguration</ng-container>
        @if (eventConfiguration.form.dirty) {
          <div class="dirty-text" i18n>modifiziert</div>
        }
      </div>
    </ng-template>

    <form class="tab-content event-configuration-form" [formGroup]="eventConfiguration.form" (ngSubmit)="saveConfiguration()">
      <dt-event-configuration></dt-event-configuration>

      <button
        mat-raised-button
        color="primary"
        [disabled]="eventConfiguration.form.invalid || eventConfiguration.form.disabled"
        [dtOverlayProgress]="savingInProgress"
      >
        <mat-icon>save</mat-icon><ng-container i18n>Speichern</ng-container>
      </button>
      <button mat-raised-button type="button" [disabled]="eventConfiguration.form.disabled" (click)="resetConfiguration()">
        <mat-icon>device_reset</mat-icon><ng-container i18n>Zurücksetzen</ng-container>
      </button>
    </form>
  </mat-tab>

  @if (eventManagementService.canEditEvent(this.event)) {
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="editable-tab-label">
          <ng-container i18n>Fragebogen</ng-container>
          @if (questionnaireDirty) {
            <div class="dirty-text" i18n>modifiziert</div>
          }
        </div>
      </ng-template>
      <dt-event-questionnaire-editor [event]="event" (dirtyChange)="questionnaireDirty = $event"></dt-event-questionnaire-editor>
    </mat-tab>
  }
</mat-tab-group>

<ng-template #errorTemplate>
  <div class="error-container">
    @switch (error) {
      @case ('network') {
        <mat-error class="dt-error" i18n>Beim Laden der Veranstaltung ist ein Fehler aufgetreten.</mat-error>
      }
      @case ('permissions') {
        <mat-error class="dt-error" i18n>Du besitzt keine Berechtigung zu dieser Veranstaltung.</mat-error>
      }
    }
  </div>
</ng-template>
